module.exports = __webpack_public_path__ + "img/efficient.3812a8d7.svg";